import { configuration } from "../routes/routeConstants";
import { CONFIGURATION_PERMISSIONS } from "./permissions";

export const CONFIGURATION_TABS = [
  {
    label: "Product",
    value: configuration.productList,
    permissions: [
      CONFIGURATION_PERMISSIONS.VIEW_PRODUCT_LIST,
      CONFIGURATION_PERMISSIONS.ADD_PRODUCT,
      CONFIGURATION_PERMISSIONS.UPDATE_PRODUCT,
      CONFIGURATION_PERMISSIONS.APPROVE_PRODUCT,
    ],
  },
  {
    label: "Manufacturing Site",
    value: configuration.siteList,
    permissions: [
      CONFIGURATION_PERMISSIONS.VIEW_MANUFACTURING_SITE_LIST,
      CONFIGURATION_PERMISSIONS.ADD_MANUFACTURING_SITE,
      CONFIGURATION_PERMISSIONS.UPDATE_MANUFACTURING_SITE,
      CONFIGURATION_PERMISSIONS.APPROVE_MANUFACTURING_SITE,
    ],
  },
  {
    label: "Unit Operation",
    value: configuration.uopList,
    permissions: [
      CONFIGURATION_PERMISSIONS.VIEW_UNIT_OPERATION_LIST,
      CONFIGURATION_PERMISSIONS.ADD_UNIT_OPERATION,
      CONFIGURATION_PERMISSIONS.UPDATE_UNIT_OPERATION,
      CONFIGURATION_PERMISSIONS.APPROVE_UNIT_OPERATION,
    ],
  },
  {
    label: "Parameter",
    value: configuration.paramterList,
    permissions: [
      CONFIGURATION_PERMISSIONS.VIEW_PARAMETER_LIST,
      CONFIGURATION_PERMISSIONS.ADD_PARAMETER,
      CONFIGURATION_PERMISSIONS.UPDATE_PARAMETER,
      CONFIGURATION_PERMISSIONS.DELETE_PARAMETER,
      CONFIGURATION_PERMISSIONS.RESTORE_PARAMETER,
      CONFIGURATION_PERMISSIONS.APPROVE_PARAMETER,
      CONFIGURATION_PERMISSIONS.REORDER_PARAMETERS,
      CONFIGURATION_PERMISSIONS.ADD_PARAMETER_PHASE,
      CONFIGURATION_PERMISSIONS.ADD_PARAMETER_TABLE,
      CONFIGURATION_PERMISSIONS.DELETE_PARAMETER_PHASE,
      CONFIGURATION_PERMISSIONS.DELETE_PARAMETER_TABLE,
    ],
  },
  {
    label: "Audit Trail",
    value: configuration.configAuditTrail,
    permissions: [CONFIGURATION_PERMISSIONS.AUDIT_TRAIL],
  },
  {
    label: "Legacy Audit Trail",
    value: configuration.auditList,
    permissions: [CONFIGURATION_PERMISSIONS.AUDIT_TRAIL],
  },
];
